import {
    SavePreferencesRequest,
    IUserPreferences,
    IUserPreferencesService,
    ClearPreferencesRequest,
    DeletePreferencesRequest,
} from "@shared/mirage/services/IUserPreferencesService";
import { BaseApiService } from "./BaseApiService";

export class UserPreferencesService extends BaseApiService implements IUserPreferencesService {
    constructor() {
        super("mirage/userPreferences");
    }
    public async getPreferences(): Promise<IUserPreferences | null> {
        const response = await this.httpInstance().get(`/`);
        return response.data;
    }
    public async savePreferences(req: SavePreferencesRequest): Promise<void> {
        const response = await this.httpInstance().post(`/savePreferences`, req);
        return response.data;
    }
    public async clearPreferences(req: ClearPreferencesRequest): Promise<void> {
        const response = await this.httpInstance().post(`/clearPreferences`, req);
        return response.data;
    }
    public async deletePreference(req: DeletePreferencesRequest) {
        const response = await this.httpInstance().delete(`/`, { data: req });
        return response.data;
    }
}
